/* istanbul ignore file */
import { useBaseCrudService } from 'framework/crud';
import { usePeopleManagementApi } from 'infrastructure/api';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import contractFilterValidation from 'domain/people/contracts/List/contractFilterValidation';
import moment from 'moment/moment';

const RESOURCE_URL = '/contracts';

export const READ_CONTRACT = 'PEOPLE_MANAGEMENT_CONTRACT_GET_CONTRACT';
export const GET_ALL_CONTRACTS_LIST = 'PEOPLE_MANAGEMENT_CONTRACT_LIST_SEARCH';

const CONTRACT_REMAIN_MONTHS_WARN = 2;

export const getPreviousContract = (contracts: any[], currentContract: Dictionary<any>) => {
  const currentDate = (format = DATE_FORMAT.INPUT_VALUE) => moment.utc(moment.utc().format(format)).toString();
  const startDateOfCurrentContract = currentContract.startDate != null ? currentContract.startDate : currentDate;
  const previousContracts = contracts
    .filter(contract => startDateOfCurrentContract >= contract.endDate)
    // @ts-ignore
    .sort((a, b) => new Date(b.endDate) - new Date(a.endDate));

  return previousContracts[0];
};

/**
 * Contracts service.
 */
const useContractsService = () => {
  const { sendPostRequest } = usePeopleManagementApi();
  const { getMonthsBetween } = useDateService();

  const baseCrudRequests = useBaseCrudService({
    singleResourceUrl: `${RESOURCE_URL}/:id`,
    listResourceUrl: RESOURCE_URL,
    useService: usePeopleManagementApi,
  });

  const search = async (request: any) => {
    const response = await sendPostRequest(`${RESOURCE_URL}/search`, { searchRequest: request });
    const result = await response.json();
    return result;
  };

  const isContractExpired = (dateValue: moment.MomentInput) => getMonthsBetween(dateValue)! < 0;

  const isContractWillExpireSoon = (dateValue: moment.MomentInput) => {
    const monthDiff = getMonthsBetween(dateValue);

    return monthDiff! <= CONTRACT_REMAIN_MONTHS_WARN && monthDiff! >= 0;
  };

  const isContractActive = (startDate: moment.MomentInput, endDate: moment.MomentInput) =>
    getMonthsBetween(startDate)! <= 0 && !isContractExpired(endDate);

  const getFiltersValidationSchema = () => Promise.resolve(contractFilterValidation);

  return {
    ...baseCrudRequests,
    search,
    isContractActive,
    isContractExpired,
    isContractWillExpireSoon,
    getFiltersValidationSchema,
  };
};

export default useContractsService;
